/**
 * Component to poll a given handler for new data on a certain interval.
 */
import { useEffect } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  intervalInMS: PropTypes.number.isRequired,
  actionCreator: PropTypes.func.isRequired,
};

export default function Poll({ intervalInMS, actionCreator }) {
  useEffect(() => {
    const intervalId = setInterval(actionCreator, intervalInMS);
    const cleanupFunc = () => {
      clearInterval(intervalId);
    };

    return cleanupFunc;
    /* Empty array indicates that the component should not update for any variable change */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}

Poll.propTypes = propTypes;
